"use strict";
exports.__esModule = true;
exports.REQUIRED_DATE_LENGTH = void 0;
exports.REQUIRED_DATE_LENGTH = 10; // Length of 10 equals MM/DD/YYYY length
